<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="No matching records found"
        >
          <template v-slot:cell(createdTime)="{ item }">
            {{ $moment(item.createdTime).format("DD/MM/YYYY") }}
            <br />
            {{ $moment(item.updatedTime).format("(HH:mm:ss)") }}
          </template>
          <template v-slot:cell(updatedTime)="{ item }">
            {{ $moment(item.updatedTime).format("DD/MM/YYYY") }}
            <br />
            {{ $moment(item.updatedTime).format("(HH:mm:ss)") }}
          </template>
          <template v-slot:cell(status)="{ item }">
            <span :class="item.status ? 'text-success' : 'text-error'">{{
              item.status ? "Active" : "Inactive"
            }}</span>
          </template>
          <template v-slot:cell(actions)="{ item }">
            <div class="d-flex justify-content-center">
              <router-link :to="'/manageRole/detail/' + item.id">
                <b-button variant="link" class="text-warning px-1 py-0">
                  <font-awesome-icon icon="pencil-alt" title="Edit" />
                </b-button>
              </router-link>
              <b-button
                variant="link"
                class="text-danger px-1 py-0"
                @click="deleteData(item.id)"
              >
                <font-awesome-icon
                  icon="trash-alt"
                  title="Delete"
                  class="main-color"
                />
              </b-button>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <Pagination
      @handleChangeTake="handleChangeTake"
      :pageOptions="pageOptions"
      :filter="filter"
      :rows="rows"
      @pagination="pagination"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalSuccess
      ref="modalAlert"
      msg="ลบข้อมูลสำเร็จ"
      @close="closeModalAlert"
    />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/ModalLoading";
import ModalSuccess from "@/components/ModalSuccess";
import Pagination from "@/components/Pagination";
export default {
  components: {
    ModalLoading,
    ModalSuccess,
    Pagination,
  },
  props: {
    filter: {
      required: true,
      type: Object,
    },
    pageOptions: {
      required: true,
      type: Array,
    },
    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
    showingTo: {
      required: true,
      type: Number,
    },
  },
  methods: {
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
    },
    chkBirthday(birthday) {
      let birthDate = birthday.search("00:00:00");
      if (birthDate === -1) {
        return true;
      } else {
        return false;
      }
    },
    async deleteData(id) {
      this.$refs.modalLoading.show();
      const { data } = await this.$Axios.delete(
        `${process.env.VUE_APP_API}/Role/${id}`
      );
      this.$emit("getData");
      this.$refs.modalAlert.show();
      this.$refs.modalLoading.hide();
      setTimeout(() => {
        this.$refs.modalAlert.hide();
      }, 2000);
    },
    closeModalAlert() {
      this.$refs.modalAlert.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--secondary-color);
  color: var(--font-color);
}
.color-red {
  color: #dc3545;
}
.color-green {
  color: #28a745;
}
.color-blue {
  color: lightcoral;
}
</style>
